import React from 'react';

import st from './modalCard.module.scss';
import cn from 'classnames';

const ModalCard = (props: any) => {
  
  let {
    header= "",
    oncancel = () =>'',
    onsave = () =>'',
    children,
    style = {}
  } = props
  
  return (
    <div className={st.container} style={style}>
      <div className={st.header}>
        {header}
      </div>
      <div className={st.main}>
        {children}
      </div>
      <div className={st.footer}>
        <div className={cn(st.cancel, st.butt)} onClick={oncancel}>
          Отмена
        </div>
        <div className={cn(st.save, st.butt)} onClick={onsave}>
          Сохранить
        </div>
      </div>
    </div>
  )
}
export default ModalCard;